import { useParams } from 'react-router-dom';
import { useContext } from 'react';
import { OrderQuery } from '../../generated/graphql';
import orderToAPI from '../helpers/orderToApi';
import { OrderContext } from '../../context/OrderContext';
import useDemoCampaign from './demoCampaign';
import { isDefined } from '../helpers/index';

const useDemoOrder = () : {
  order?: OrderQuery['orderById']
} => {
  const { slug } = useParams();
  const { order } = useContext(OrderContext);
  const { campaign } = useDemoCampaign();

  if (slug !== 'demo' || !isDefined(campaign)) return { order: undefined };

  const basicOrder = orderToAPI(order, campaign, true);

  return {
    order: {
      ...basicOrder,
      _id: '63ce97bf41275c452998e8e3',
      paymentStatus: 'succeeded',
      code: 'ABC123',
      quantities: basicOrder.quantities.map((q) => {
        const article = campaign?.articles?.find((a) => a._id === q.articleId);
        return ({
          ...q,
          price: article?.price || 0,
          article: article || { _id: '', name: 'string' },
        });
      }),
    },
  } as const;
};

export default useDemoOrder;
